import * as React from 'react'
import styled from 'styled-components'
import * as constants from '../../static/constants'
import InputLabel from './InputLabel'
import ClassNames from 'classnames'

interface IProps {
  label: null | string
  children: React.ReactNode
}

const WithLabel: React.VFC<IProps> = ({ label, children }) => {
  return (
    <Wrapper>
      {label && <InputLabel label={label} />}
      <div className={ClassNames(['Data', { noLabel: !label }])}>{children}</div>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;

  @media (max-width: ${constants.BREAKPOINT_TABLET_SMALL}px) {
    flex-direction: column;
  }
  .Data {
    flex: 1;
    @media (max-width: ${constants.BREAKPOINT_TABLET_SMALL}px) {
      width: 100%;
    }

    &.noLabel {
      padding-left: 180px;
      @media (max-width: ${constants.BREAKPOINT_TABLET_SMALL}px) {
        padding-left: 0;
      }
    }

    > * {
      display: block;
      width: 100%;
    }
  }
`

export default WithLabel
